<script setup>

import ApplicationLogo from "@/Components/ApplicationLogo.vue";
const currentYear = new Date().getFullYear();

</script>

<template>
	<footer class="bg-gray-900">
		<div class="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8">
			<div class="flex justify-center gap-x-6 md:order-3">
				<ApplicationLogo class="size-12"/>
			</div>
			<p class="mt-8 text-center text-sm/6 text-gray-400 md:order-1 md:mt-0">&copy; {{ currentYear }} SlideCub. All rights reserved.</p>
			<div class="order-2 text-xs/6 text-gray-500">
				<a href="/privacy">Privacy Policy</a>
				<span class="mx-3">|</span>
				<a href="/terms">Terms of Service</a>
				<span class="mx-3">|</span>
				<a href="/limited_use_disclosure">Limited Use Disclosure</a>

			</div>
		</div>
	</footer>
</template>

<style scoped>

</style>